module.exports = __webpack_public_path__ + "static/04-0d4e21bd4c3975b0afdc9acf75a6d115.jpg";